import { ErrorInfo, Component } from 'react'
import { TrackJS } from 'trackjs'

import { env } from '@/config'

export class ErrorBoundary extends Component {
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error })
    if (!TrackJS.isInstalled()) {
      console.error(error)
      return
    }

    TrackJS.track(error)
    if (errorInfo && errorInfo.componentStack && env.NODE_ENV === 'development') {
      console.log(errorInfo.componentStack)
    }
  }

  render() {
    const { children } = this.props

    return children
  }
}
